/**
 * Wrapper that imports all data and deligates to the four main modules.
 */

var VRC = VRC || {};

VRC.ImportService = (function(){

	var importData = function(data){

		g_voyage_planning.ParseLogData(null, data.voyageLogs);
		VRC.BulkState.importData(data.bulk);
		VRC.CurrentVoyage.importData(data.voyage);
		ParseContainers(data.deck.containers);

	};

	return {
		importData : importData
	}
})();
